// 英雄位置映射表：idName -> ['top'|'jungle'|'mid'|'adc'|'support'] []
// 数据基于近期版本职业赛 / 高分段常见出场情况整理（多位置英雄按主流程度排序）
// 未在表中出现的英雄会默认归到 "其他"，在「全部」筛选下依然出现。

export const POSITIONS = ['top', 'jungle', 'mid', 'adc', 'support'];

export const POSITION_LABELS = {
  top:     { cn: '上单',  short: '上', en: 'TOP' },
  jungle:  { cn: '打野',  short: '野', en: 'JUN' },
  mid:     { cn: '中单',  short: '中', en: 'MID' },
  adc:     { cn: '下路',  short: '下', en: 'ADC' },
  support: { cn: '辅助',  short: '辅', en: 'SUP' },
};

// 注意 idName 使用 DataDragon 的内部命名（如 Wukong = "MonkeyKing", Vel'Koz = "Velkoz" 等）
export const CHAMPION_POSITIONS = {
  Aatrox: ['top'],
  Ahri: ['mid'],
  Akali: ['mid', 'top'],
  Akshan: ['mid', 'top'],
  Alistar: ['support'],
  Ambessa: ['top', 'mid'],
  Amumu: ['jungle', 'support'],
  Anivia: ['mid'],
  Annie: ['mid', 'support'],
  Aphelios: ['adc'],
  Ashe: ['adc', 'support'],
  AurelionSol: ['mid'],
  Aurora: ['top', 'mid'],
  Azir: ['mid'],
  Bard: ['support'],
  Belveth: ['jungle'],
  Blitzcrank: ['support'],
  Brand: ['support', 'mid'],
  Braum: ['support'],
  Briar: ['jungle'],
  Caitlyn: ['adc'],
  Camille: ['top', 'support'],
  Cassiopeia: ['mid', 'top'],
  Chogath: ['top', 'mid'],
  Corki: ['mid', 'adc'],
  Darius: ['top'],
  Diana: ['jungle', 'mid'],
  Draven: ['adc'],
  DrMundo: ['top', 'jungle'],
  Ekko: ['jungle', 'mid'],
  Elise: ['jungle', 'support'],
  Evelynn: ['jungle'],
  Ezreal: ['adc', 'mid'],
  Fiddlesticks: ['jungle', 'support'],
  Fiora: ['top'],
  Fizz: ['mid'],
  Galio: ['mid', 'support'],
  Gangplank: ['top', 'mid'],
  Garen: ['top'],
  Gnar: ['top'],
  Gragas: ['top', 'jungle', 'mid', 'support'],
  Graves: ['jungle', 'top'],
  Gwen: ['top', 'jungle'],
  Hecarim: ['jungle'],
  Heimerdinger: ['top', 'mid', 'support'],
  Hwei: ['mid', 'support'],
  Illaoi: ['top'],
  Irelia: ['top', 'mid'],
  Ivern: ['jungle'],
  Janna: ['support'],
  JarvanIV: ['jungle'],
  Jax: ['top', 'jungle'],
  Jayce: ['top', 'mid'],
  Jhin: ['adc'],
  Jinx: ['adc'],
  Kaisa: ['adc'],
  Kalista: ['adc'],
  Karma: ['support', 'mid'],
  Karthus: ['jungle', 'mid'],
  Kassadin: ['mid'],
  Katarina: ['mid'],
  Kayle: ['top', 'mid'],
  Kayn: ['jungle'],
  Kennen: ['top', 'mid'],
  Khazix: ['jungle'],
  Kindred: ['jungle'],
  Kled: ['top'],
  KogMaw: ['adc'],
  Ksante: ['top'],
  Leblanc: ['mid'],
  LeeSin: ['jungle'],
  Leona: ['support'],
  Lillia: ['jungle', 'top'],
  Lissandra: ['mid', 'top'],
  Lucian: ['adc', 'mid'],
  Lulu: ['support', 'top'],
  Lux: ['mid', 'support'],
  Malphite: ['top', 'support'],
  Malzahar: ['mid'],
  Maokai: ['support', 'top', 'jungle'],
  MasterYi: ['jungle'],
  Mel: ['mid', 'support'],
  Milio: ['support'],
  MissFortune: ['adc', 'support'],
  MonkeyKing: ['top', 'jungle'], // Wukong
  Mordekaiser: ['top'],
  Morgana: ['support', 'mid'],
  Naafiri: ['mid', 'jungle'],
  Nami: ['support'],
  Nasus: ['top'],
  Nautilus: ['support'],
  Neeko: ['mid', 'support'],
  Nidalee: ['jungle'],
  Nilah: ['adc'],
  Nocturne: ['jungle', 'mid'],
  Nunu: ['jungle'],
  Olaf: ['top', 'jungle'],
  Orianna: ['mid'],
  Ornn: ['top'],
  Pantheon: ['support', 'top', 'mid'],
  Poppy: ['top', 'jungle', 'support'],
  Pyke: ['support'],
  Qiyana: ['mid'],
  Quinn: ['top'],
  Rakan: ['support'],
  Rammus: ['jungle'],
  RekSai: ['jungle'],
  Rell: ['support'],
  Renata: ['support'],
  Renekton: ['top'],
  Rengar: ['jungle', 'top'],
  Riven: ['top'],
  Rumble: ['top', 'mid'],
  Ryze: ['mid', 'top'],
  Samira: ['adc'],
  Sejuani: ['jungle'],
  Senna: ['support', 'adc'],
  Seraphine: ['support', 'mid', 'adc'],
  Sett: ['top', 'support'],
  Shaco: ['jungle', 'support'],
  Shen: ['top', 'support'],
  Shyvana: ['jungle'],
  Singed: ['top'],
  Sion: ['top'],
  Sivir: ['adc'],
  Skarner: ['jungle'],
  Smolder: ['adc', 'top'],
  Sona: ['support'],
  Soraka: ['support'],
  Swain: ['mid', 'support'],
  Sylas: ['mid', 'jungle'],
  Syndra: ['mid'],
  TahmKench: ['top', 'support'],
  Taliyah: ['jungle', 'mid'],
  Talon: ['mid', 'jungle'],
  Taric: ['support'],
  Teemo: ['top'],
  Thresh: ['support'],
  Tristana: ['adc', 'mid'],
  Trundle: ['top', 'jungle'],
  Tryndamere: ['top'],
  TwistedFate: ['mid', 'support'],
  Twitch: ['adc'],
  Udyr: ['jungle'],
  Urgot: ['top'],
  Varus: ['adc', 'mid'],
  Vayne: ['adc', 'top'],
  Veigar: ['mid', 'support'],
  Velkoz: ['mid', 'support'],
  Vex: ['mid'],
  Vi: ['jungle'],
  Viego: ['jungle', 'mid'],
  Viktor: ['mid'],
  Vladimir: ['top', 'mid'],
  Volibear: ['top', 'jungle'],
  Warwick: ['jungle', 'top'],
  Xayah: ['adc'],
  Xerath: ['support', 'mid'],
  XinZhao: ['jungle'],
  Yasuo: ['mid', 'top', 'adc'],
  Yone: ['mid', 'top'],
  Yorick: ['top'],
  Yuumi: ['support'],
  Zac: ['jungle'],
  Zed: ['mid'],
  Zeri: ['adc'],
  Ziggs: ['mid', 'adc'],
  Zilean: ['support', 'mid'],
  Zoe: ['mid'],
  Zyra: ['support'],
};

// 给一个英雄推断位置：先查表，没有就退化为按 DataDragon tags 默认推测
export const inferPositions = (idName, tags = []) => {
  if (CHAMPION_POSITIONS[idName]) {
    return CHAMPION_POSITIONS[idName];
  }
  // 未收录英雄按 tags 兜底（避免新英雄出现后完全没分类）
  if (tags.includes('Marksman')) return ['adc'];
  if (tags.includes('Support')) return ['support'];
  if (tags.includes('Tank')) return ['top'];
  if (tags.includes('Fighter')) return ['top'];
  if (tags.includes('Assassin')) return ['mid'];
  if (tags.includes('Mage')) return ['mid'];
  return [];
};
